/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { useDispatch, useSelector } from 'react-redux';
import { Alert, Text, Button, SecurityHelper } from 'sarsaparilla';

import { authModalActions } from 'shared-ui/auth/redux';

export function MustLogInNotice() {
    // Tieing this component to the store so it updates when the auth state changes
    const account = useSelector((state) => state.auth.account);
    const dispatch = useDispatch();
    const isLoggedIn = SecurityHelper.isLoggedIn();

    const handleClick = (event) => {
        event.preventDefault();
        dispatch(authModalActions.openLoginModal());
    };

    // Render nothing if user is logged in
    if (account && isLoggedIn) {
        return null;
    }

    // Otherwise render notice
    return (
        <div data-component="MustLogInNotice">
            <Alert type="warning">
                <Text size="sm">
                    You must be logged in to add an item to your cart. To sign up or log
                    in to your account,{' '}
                    <Button
                        className="shared-must-log-in-notice-button"
                        appearance="link"
                        onClick={handleClick}
                        aria-label="Click here to sign up or log in to your account in order to add an item to your cart"
                    >
                        click here
                    </Button>
                    .
                </Text>
            </Alert>
        </div>
    );
}
